function getLocalStorageItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}
function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {}
}
function removeLocalStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
}

document.addEventListener("DOMContentLoaded", function () {
  removeLocalStorageItem('removedItems'); // Clears storage properly on page load
  attachRemoveEventListeners(); // Attach event listeners after page load
});


// Function to remove item from cart whole product delete
// function removeItemFromCart(line) {
//   fetch('/cart/change.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       line: line, // Line item position (1-based index)
//       quantity: 0
//     })
//   })
//   .then(response => response.json())
//   .then(cart => {
//     if (cart.items_removed && cart.items_removed.length > 0) {
//     let removedItem = cart.items_removed[0];
//     console.log('✅ Item removed:', cart.items_removed[0].variant_id, 'Quantity:', removedItem.quantity);
//     storeDeletedVariant(cart.items_removed[0].variant_id, removedItem.quantity);
//     //showUndoMessage();
//     refreshCart(); // Refresh only the cart
//     }
//   })  
//   .catch(error => console.error('❌ Error removing item:', error));
// }

// delete item or decrement quantity from cart
function removeItemFromCart(line) {
  // Show loader on button while request is in flight
  const removeBtn = document.querySelector(`button.cart-remove-button[data-index="${line}"]`);
  const loader = createCartLoader();
  if (removeBtn) {
    removeBtn.disabled = true;
    removeBtn.classList.add('loading');
    removeBtn.appendChild(loader);
  }

  // first read cart to determine current quantity
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (!cart || !cart.items) {
        console.error('❌ Cart data is empty or invalid.');
        removeLoader(loader, removeBtn);
        return Promise.reject();
      }
      const item = cart.items[line - 1];
      if (!item) {
        console.error('❌ No item found at line', line);
        removeLoader(loader, removeBtn);
        return Promise.reject();
      }
      const newQty = item.quantity - 1;

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: newQty
        })
      });
    })
    .then(response => response && response.json())
    .then(updatedCart => {
      if (!updatedCart) return;
      console.log('✅ Updated quantity for line', line);

      // check if item still exists in cart after update
      const stillExists = updatedCart.items ? updatedCart.items[line - 1] : null;

      if (!stillExists && updatedCart.items_removed && updatedCart.items_removed.length) {
        // item completely removed
        storeDeletedVariant(updatedCart.items_removed[0].variant_id);

        const itemElem = removeBtn ? removeBtn.closest('.cart-item') : null;
        if (itemElem) itemElem.remove();

        // update bubble count
        const bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (bubble) {
          const current = parseInt(bubble.textContent) || 0;
          bubble.textContent = Math.max(current - 1, 0);

          const vis = bubble.parentElement ? bubble.parentElement.querySelector('.visually-hidden') : null;
          if (vis) vis.textContent = bubble.textContent + ' items';
        }
      }



      // remove loader & reattach listeners immediately for snappy UI
      attachRemoveEventListeners();
      removeLoader(loader, removeBtn);
      // refresh cart in background so UI doesn't wait on it
      if (typeof refreshCart === 'function') {
        setTimeout(refreshCart, 0);
      }
      return updatedCart;
    })
    .catch(error => {
      if (error) console.error('❌ Error removing item:', error);
      removeLoader(loader, removeBtn);
    });
}

// Helper function to create a loader element
function createCartLoader() {
  const loader = document.createElement('div');
  loader.className = 'cart-item-loader';
  loader.innerHTML = `
    <div class="loader-spinner">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
    </div>
  `;
  
  // Add styles if not already present
  if (!document.getElementById('cart-loader-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-loader-styles';
    style.textContent = `
      .cart-item-loader {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
      }
      .loader-spinner {
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .spinner {
        width: 100%;
        height: 100%;
        animation: rotate 2s linear infinite;
      }
      .spinner .path {
        stroke: #333;
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
      }
      @keyframes rotate {
        100% { transform: rotate(360deg); }
      }
      @keyframes dash {
        0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35px; }
        100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124px; }
      }
    `;
    document.head.appendChild(style);
  }
  
  return loader;
}

// ensure CartItems base class exists for other components
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    // minimal stub used by new-cart-drawer-items
    getSectionsToRender() { return []; }
  }
  customElements.define('cart-items', CartItems);
}

// Helper function to remove loader
function removeLoader(loader, btn) {
  if (loader && loader.parentElement) {
    loader.remove();
  }
  if (btn) {
    btn.disabled = false;
    btn.classList.remove('loading');
  }
}

// Function to add an item back to the cart (Undo feature)
function addItemToCart(variantId, quantity = 1) {
  // Show loader in undo button
  const undoBtn = document.querySelector('.undo-link');
  const loader = createCartLoader();
  if (undoBtn) {
    undoBtn.disabled = true;
    undoBtn.classList.add('loading');
    undoBtn.appendChild(loader);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Shopify returns a status field for errors
    if (!cart || cart.status) {
      console.error('❌ Invalid cart response or error:', cart);
      removeLoader(loader, undoBtn);
      return;
    }
    
    // item_count may be zero if cart is empty, so don't rely on it
    console.log('✅ Item restored:', cart);
    
    // Track facebook event if available
    if (typeof fbq !== 'undefined' && window.Shopify && window.Shopify.currency) {
      fbq('track', 'AddToCart', {
        content_type: 'product',
        currency: window.Shopify.currency.active
      });
    }
    
    refreshCart();
    attachRemoveEventListeners();
    // hide bought-together product entry if present
    document.querySelectorAll(`.also-like-product-content[data-cross-sell-product="${variantId}"]`).forEach(el=>{
      el.closest('.also-like-product')?.remove();
    });
    removeLoader(loader, undoBtn);
  })
  .catch(error => {
    console.error('❌ Error restoring item:', error);
    removeLoader(loader, undoBtn);
  });
}


// Helper for updating the cart icon link text and bubble. Accepts an optional count; if omitted we fetch current cart.
function updateCartIconBubble(count) {
  // make available on window for other scripts just in case
  window.updateCartIconBubble = updateCartIconBubble;
  if (typeof count === 'number') {
    // Update both the default header cart and the custom FW header cart.
    document.querySelectorAll('#cart-icon-bubble, #cart-icon-bubble1').forEach((cartIcon) => {
      const bubbleSpan = cartIcon.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const visSpan = cartIcon.querySelector('.cart-count-bubble span.visually-hidden');

      if (bubbleSpan) bubbleSpan.textContent = count;
      if (visSpan) visSpan.textContent = `${count} items`;

      // FW header renders its count in the link text instead of a count bubble.
      if (cartIcon.id === 'cart-icon-bubble1' && !bubbleSpan) {
        const countText = Array.from(cartIcon.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim().length
        );
        if (countText) countText.textContent = `Bag (${count})`;
      }
    });
    return;
  }

  // no count provided, fetch current cart state
  fetch('/cart.js')
    .then((r) => r.json())
    .then((data) => {
      updateCartIconBubble(data.item_count);
    })
    .catch((e) => {
      console.error('Error fetching cart for bubble update:', e);
    });
}

// Function to refresh only the cart (No full page reload)
function refreshCart() {
  // returns a promise so callers can wait for the update to finish
  // Optimized: Use Promise.all to parallelize requests if needed, but consolidated into single fetch
  return fetch('/?section_id=new-cart-drawer')
    .then((response) => response.text())
    .then((html) => {
      // Parse the response once
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Update cart drawer
      const newCartDrawer = doc.querySelector('new-cart-drawer');
      if (newCartDrawer) {
        const cartDrawerElement = document.querySelector('new-cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.innerHTML = newCartDrawer.innerHTML;
        }
      }
      
      // Update cart icon bubble if present in response
      const cartIconSection = doc.querySelector('#shopify-section-cart-icon-bubble');
      if (cartIconSection) {
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble) {
          const newIconContent = cartIconSection.querySelector('#cart-icon-bubble');
          if (newIconContent) {
            cartIconBubble.innerHTML = newIconContent.innerHTML;
          }
        }
      }
      
      if (typeof window.initCartDrawerSlick === 'function') {
        window.initCartDrawerSlick();
      }

      showUndoMessage();

      // ensure drawer is closed after refresh (might have been added inadvertently)
      // but don't close if it's currently open (e.g., after item removal)
      const drawerEl = document.querySelector('new-cart-drawer');
      if (drawerEl && !drawerEl.classList.contains('active')) {
        drawerEl.classList.remove('active','animate');
      }
      
      // Update cart count
      const cartCount = doc.querySelector('.item_count_display_none');
      if (cartCount) {
        const count = Number.parseInt(cartCount.textContent.trim(), 10);
        if (Number.isFinite(count)) updateCartIconBubble(count);
        const countBubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        countBubbles.forEach(el => el.textContent = count);
        
        const visuallyHidden = document.querySelectorAll('.cart-count-bubble span.visually-hidden');
        visuallyHidden.forEach(el => el.textContent = count + ' items');
      }
    })
    .then(() => {
      if (typeof updateCartIconBubble === 'function') updateCartIconBubble();
    })
    .catch((error) => {
      console.error('❌ Error refreshing cart:', error);
    });
}
function showUndoMessage() {
  let deletedItems = getLocalStorageItem('removedItems') || '';
  let deletedList = deletedItems.split(',').filter(Boolean);
  const deletedCount = deletedList.length;
  console.log(deletedCount, "=====================");

  if (deletedCount === 0) return;

  // Select the target div
  const messageContainer = document.getElementById('undo-message-text');

  if (!messageContainer) {
      console.error('❌ Error: Undo message container not found.');
      return;
  }

  // Append the message instead of replacing innerHTML
  messageContainer.innerHTML = ''; // Clear previous messages
  const undoMessage = document.createElement('div');
  undoMessage.className = 'undo-message-content';
  undoMessage.innerHTML = `
  <p>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
  <path d="M4.5 1H8.5M0.5 3H12.5M11.1667 3L10.6991 10.0129C10.629 11.065 10.5939 11.5911 10.3667 11.99C10.1666 12.3412 9.8648 12.6235 9.50113 12.7998C9.088 13 8.56073 13 7.5062 13H5.4938C4.43927 13 3.91202 13 3.49889 12.7998C3.13517 12.6235 2.83339 12.3412 2.63332 11.99C2.40607 11.5911 2.371 11.065 2.30086 10.0129L1.83333 3M5.16667 6V9.33333M7.83333 6V9.33333" stroke="#1a1a1a" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
    ${deletedCount} item${deletedCount > 1 ? 's' : ''} removed from bag
    </p>
    <a href="#" class="undo-link">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path d="M5.34729 14.2324H11.3473C13.4173 14.2324 15.0973 12.5524 15.0973 10.4824C15.0973 8.41242 13.4173 6.73242 11.3473 6.73242H3.09729" stroke="#1A1A1A" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.82271 8.60758L2.90271 6.68758L4.82271 4.76758" stroke="#1A1A1A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    Undo
    </a>
  `;

  messageContainer.appendChild(undoMessage);

  // Attach event listener for undo action
  undoMessage.querySelector('.undo-link').addEventListener('click', (event) => {
      event.preventDefault();
      undoDelete(); // Call undo function
      // messageContainer.innerHTML = ''; // Clear the message after undo
  });
}



   // Store deleted variant IDs in localStorage only single id
  //  function storeDeletedVariant(variantId) {
  //   let deletedItems = localStorage.getItem('removedItems');
  //   deletedItems = deletedItems ? deletedItems.split(',') : [];
    
  //   if (!deletedItems.includes(variantId)) {
  //     deletedItems.push(variantId);
  //     localStorage.setItem('removedItems', deletedItems.join(','));
  //   }
  // }


  // allow duplicate id to add in local storage
  function storeDeletedVariant(variantId) {
    let deletedItems = getLocalStorageItem('removedItems');
    deletedItems = deletedItems ? deletedItems.split(',') : [];
  
    deletedItems.push(variantId); // Store multiple entries of same ID
    setLocalStorageItem('removedItems', deletedItems.join(','));
  }
  

  // Store deleted variant IDs and quantities in localStorage
  // function storeDeletedVariant(variantId, quantity) {
  //   let deletedItems = JSON.parse(localStorage.getItem('removedItems')) || [];

  //   // Store variant ID with quantity
  //   // deletedItems.push({ variantId, quantity });
  //   deletedItems.push(`${variantId}|${quantity}`);
  //   localStorage.setItem('removedItems', JSON.stringify(deletedItems));
  // }

  
  // Undo last deleted item
  // function undoDelete() {
  //   let deletedItems = localStorage.getItem('removedItems') || '';
  //   let deletedList = deletedItems.split(',').filter(Boolean);

  //   if (deletedList.length === 0) return;

  //   const lastDeletedVariant = deletedList.pop();
  //   addItemToCart(lastDeletedVariant);
  //   localStorage.setItem('removedItems', deletedList.join(','));
  // }


  // undo deleted product qunaty
  function undoDelete() {
    let deletedItems = getLocalStorageItem('removedItems') || '';
    let deletedList = deletedItems.split(',').filter(Boolean);
  
    if (deletedList.length === 0) return;
  
    const lastDeletedVariant = deletedList.pop();
  
    addItemToCart(lastDeletedVariant, 1); // Restore one quantity
    setLocalStorageItem('removedItems', deletedList.join(','));
  }
  



  // Undo last deleted item
//   function undoDelete() {
//     let deletedItems = JSON.parse(localStorage.getItem('removedItems')) || [];
    
//     if (deletedItems.length === 0) {
//         localStorage.removeItem('removedItems');
//         return;
//     }

//     // Retrieve and split the last deleted item
//     let lastDeleted = deletedItems.pop();
//     let [variantId, quantity] = lastDeleted.split('|');

//     // Restore variant with original quantity
//     addItemToCart(parseInt(variantId, 10), parseInt(quantity, 10));

//     // Update localStorage
//     if (deletedItems.length > 0) {
//         localStorage.setItem('removedItems', JSON.stringify(deletedItems));
//     } else {
//         localStorage.removeItem('removedItems');
//     }
// }

// respond to any cart update (ajax adds) and hide matching bought-together products
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event.cartData && event.cartData.items) {
    event.cartData.items.forEach((item) => {
      const selector = `.also-like-product-content[data-cross-sell-product="${item.variant_id}"]`;
      document.querySelectorAll(selector).forEach(el => {
        const parent = el.closest('.also-like-product');
        if (parent) parent.remove();
      });
    });
  }
});

// Function to reattach event listeners after cart refresh
function attachRemoveEventListeners() {
  document.querySelectorAll('button.cart-remove-button').forEach(button => {
    // remove duplicates by cloning
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    newButton.addEventListener('click', (event) => {
      event.preventDefault();
      const lineIndex = newButton.dataset.index;
      if (!lineIndex) {
        console.error("❌ Missing line index.");
        return;
      }
      removeItemFromCart(lineIndex);
    });
  });
}

document.addEventListener("DOMContentLoaded", attachRemoveEventListeners);





// ==============================OLD CODE==============================


// class CartRemoveButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('click', (event) => {
//       event.preventDefault();
//       const cartItems = this.closest('cart-items') || this.closest('new-cart-drawer-items');
//       cartItems.updateQuantity(this.dataset.index, 0);
//     });
//   }
// }

// customElements.define('cart-remove-button', CartRemoveButton);

// class CartItems extends HTMLElement {
//   constructor() {
//     super();
//     this.lineItemStatusElement =
//       document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

//     const debouncedOnChange = debounce((event) => {
//       this.onChange(event);
//     }, ON_CHANGE_DEBOUNCE_TIMER);

//     this.addEventListener('change', debouncedOnChange.bind(this));
//   }

//   cartUpdateUnsubscriber = undefined;

//   connectedCallback() {
//     this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
//       if (event.source === 'cart-items') {
//         return;
//       }
//       this.onCartUpdate();
//     });
//   }

//   disconnectedCallback() {
//     if (this.cartUpdateUnsubscriber) {
//       this.cartUpdateUnsubscriber();
//     }
//   }

//   resetQuantityInput(id) {
//     const input = this.querySelector(`#Quantity-${id}`);
//     input.value = input.getAttribute('value');
//     this.isEnterPressed = false;
//   }

//   setValidity(event, index, message) {
//     event.target.setCustomValidity(message);
//     event.target.reportValidity();
//     this.resetQuantityInput(index);
//     event.target.select();
//   }

//   validateQuantity(event) {
//     const inputValue = parseInt(event.target.value);
//     const index = event.target.dataset.index;
//     let message = '';

//     if (inputValue < event.target.dataset.min) {
//       message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
//     } else if (inputValue > parseInt(event.target.max)) {
//       message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
//     } else if (inputValue % parseInt(event.target.step) !== 0) {
//       message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
//     }

//     if (message) {
//       this.setValidity(event, index, message);
//     } else {
//       event.target.setCustomValidity('');
//       event.target.reportValidity();
//       this.updateQuantity(
//         index,
//         inputValue,
//         document.activeElement.getAttribute('name'),
//         event.target.dataset.quantityVariantId
//       );
//     }
//   }

//   onChange(event) {
//     this.validateQuantity(event);
//   }

//   onCartUpdate() {
//     if (this.tagName === 'NEW-CART-DRAWER-ITEMS') {
//       fetch(`${routes.cart_url}?section_id=new-cart-drawer`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');
//           const selectors = ['new-cart-drawer-items', '.cart-drawer__footer'];
//           for (const selector of selectors) {
//             const targetElement = document.querySelector(selector);
//             const sourceElement = html.querySelector(selector);
//             if (targetElement && sourceElement) {
//               targetElement.replaceWith(sourceElement);
//             }
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         });
//     } else {
//       fetch(`${routes.cart_url}?section_id=main-cart-items`)
//         .then((response) => response.text())
//         .then((responseText) => {
//           const html = new DOMParser().parseFromString(responseText, 'text/html');
//           const sourceQty = html.querySelector('cart-items');
//           this.innerHTML = sourceQty.innerHTML;
//         })
//         .catch((e) => {
//           console.error(e);
//         });
//     }
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'main-cart-items',
//         section: document.getElementById('main-cart-items').dataset.id,
//         selector: '.js-contents',
//       },
//       {
//         id: 'newCartDrawer',
//         section: 'new-cart-drawer',
//         selector: '.drawer__inner',
//       },
      
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//       {
//         id: 'cart-live-region-text',
//         section: 'cart-live-region-text',
//         selector: '.shopify-section',
//       },
//       {
//         id: 'main-cart-footer',
//         section: document.getElementById('main-cart-footer').dataset.id,
//         selector: '.js-contents',
//       },
//     ];
//   }

//   updateQuantity(line, quantity, name, variantId) {
//     this.enableLoading(line);

//     const body = JSON.stringify({
//       line,
//       quantity,
//       sections: this.getSectionsToRender().map((section) => section.section),
//       sections_url: window.location.pathname,
//     });

//     fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
//       .then((response) => {
//         return response.text();
//       })
//       .then((state) => {
//         const parsedState = JSON.parse(state);
//         const quantityElement =
//           document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
//         const items = document.querySelectorAll('.cart-item');

//         if (parsedState.errors) {
//           quantityElement.value = quantityElement.getAttribute('value');
//           this.updateLiveRegions(line, parsedState.errors);
//           return;
//         }

//         this.classList.toggle('is-empty', parsedState.item_count === 0);
//         const cartDrawerWrapper = document.querySelector('new-cart-drawer');
//         const cartFooter = document.getElementById('main-cart-footer');

//         if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
//         if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

//         this.getSectionsToRender().forEach((section) => {
//           const elementToReplace =
//             document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
//           elementToReplace.innerHTML = this.getSectionInnerHTML(
//             parsedState.sections[section.section],
//             section.selector
//           );
//         });
//         const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
//         let message = '';
//         if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
//           if (typeof updatedValue === 'undefined') {
//             message = window.cartStrings.error;
//           } else {
//             message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
//           }
//         }
//         this.updateLiveRegions(line, message);

//         const lineItem =
//           document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
//         if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
//           cartDrawerWrapper
//             ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
//             : lineItem.querySelector(`[name="${name}"]`).focus();
//         } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
//           trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
//         } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
//           trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
//         }

//         publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
//       })
//       .catch(() => {
//         this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
//         const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
//         errors.textContent = window.cartStrings.error;
//       })
//       .finally(() => {
//         this.disableLoading(line);
//       });
//   }

//   updateLiveRegions(line, message) {
//     const lineItemError =
//       document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
//     if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

//     this.lineItemStatusElement.setAttribute('aria-hidden', true);

//     const cartStatus =
//       document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
//     cartStatus.setAttribute('aria-hidden', false);

//     setTimeout(() => {
//       cartStatus.setAttribute('aria-hidden', true);
//     }, 1000);
//   }

//   getSectionInnerHTML(html, selector) {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   enableLoading(line) {
//     const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
//     mainCartItems.classList.add('cart__items--disabled');

//     const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
//     const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

//     [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

//     document.activeElement.blur();
//     this.lineItemStatusElement.setAttribute('aria-hidden', false);
//   }

//   disableLoading(line) {
//     const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
//     mainCartItems.classList.remove('cart__items--disabled');

//     const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
//     const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

//     cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
//     cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
//   }
// }

// customElements.define('cart-items', CartItems);

// if (!customElements.get('cart-note')) {
//   customElements.define(
//     'cart-note',
//     class CartNote extends HTMLElement {
//       constructor() {
//         super();

//         this.addEventListener(
//           'input',
//           debounce((event) => {
//             const body = JSON.stringify({ note: event.target.value });
//             fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
//           }, ON_CHANGE_DEBOUNCE_TIMER)
//         );
//       }
//     }
//   );
// }
